<template>
    <div class=" text-center" v-if="Number(balance) > 0">
        <vs-chip color="#28C76F" style="font-size: 2em; border-radius: 5px;" class="w-full f-bold">
            {{ chipText }}
        </vs-chip>
    </div>
</template>

<script>
import { capitalize, formatCurrency } from '@/utils/helpers'

export default {
    name: 'BalanceIndicator',
    props: {
        balance: {
            type: [String, Number],
            default: 0
        },
        currency: {
            type: String,
            default: 'MXN'
        }

    },
    computed: {
        chipText() {
            return capitalize('Balance') + ': ' + formatCurrency(this.balance, this.currency)
        }
    }

}
</script>

<style></style>